import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { Col, Row } from 'reactstrap';
import TextBox from '../../shared/components/form/TextBox';

const StudentReviewRequestForm = ({
  examLabel,
  reviewWindowLabel,
  onBlur,
  handleSubmit,
}) => (
  <Form className="form" onSubmit={handleSubmit}>
    <Row>
      <Col md={12}>
        <p>
          {examLabel ? `Examen: ${examLabel}` : ''}
        </p>
        {reviewWindowLabel ? (
          <p>
            {`Periodo para solicitar revisión: ${reviewWindowLabel}`}
          </p>
        ) : null}
        <p>Completa el motivo para solicitar la revisión.</p>
      </Col>

      <Col md={12}>
        <div className="form__form-group">
          <span className="form__form-group-label">Motivo de revisión</span>
          <div className="form__form-group-field">
            <Field
              name="motivoReclamo"
              component={TextBox}
              type="textarea"
              maxLength={2048}
              placeholder="Motivo de revisión"
              onBlur={(event, value) => {
                let nextValue = '';

                if (typeof value === 'string') {
                  nextValue = value;
                } else if (event && event.target) {
                  nextValue = event.target.value;
                }

                onBlur('motivoReclamo', nextValue);
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  </Form>
);

StudentReviewRequestForm.propTypes = {
  examLabel: PropTypes.string,
  reviewWindowLabel: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

StudentReviewRequestForm.defaultProps = {
  examLabel: '',
  reviewWindowLabel: '',
};

export default reduxForm({
  form: 'studentReviewRequestForm',
})(StudentReviewRequestForm);
